import React from 'react';

export const SHLogo = () => (
  <svg
    width="134"
    height="28"
    viewBox="0 0 134 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_20758_221794)">
      <g clipPath="url(#clip1_20758_221794)">
        <path
          d="M6.54842 2C5.63885 2 5.18333 3.07714 5.8265 3.70711L22.7598 20.2929C23.403 20.9229 24.5027 20.4767 24.5027 19.5858V3C24.5027 2.44772 24.0456 2 23.4818 2H6.54842Z"
          fill="#0137FC"
        />
        <path
          d="M11.9651 23.7197C12.4474 24.1921 13.2722 23.8575 13.2722 23.1893V13.75C13.2722 13.3358 12.9294 13 12.5065 13H2.86936C2.18718 13 1.84554 13.8079 2.32792 14.2803L11.9651 23.7197Z"
          fill="#0137FC"
        />
        <path
          d="M5.25409 25.1464C5.57567 25.4614 6.12553 25.2383 6.12553 24.7929V20.5C6.12553 20.2239 5.89698 20 5.61505 20H1.2322C0.777417 20 0.549659 20.5386 0.871242 20.8536L5.25409 25.1464Z"
          fill="#0137FC"
        />
      </g>
      <path
        d="M38.5403 13.3419C37.0645 13.1364 36.5585 12.8899 36.5585 12.2323C36.5585 11.6159 37.1067 11.2049 38.0343 11.2049C39.0041 11.2049 39.5101 11.5748 39.6366 12.3967H42.2508C41.9978 10.0954 40.269 9.27344 37.9922 9.27344C35.8839 9.27344 33.9022 10.3008 33.9022 12.3967C33.9022 14.3693 34.9564 15.109 37.697 15.52C39.1727 15.7255 39.7631 16.0131 39.7631 16.7118C39.7631 17.4104 39.2571 17.8214 38.1608 17.8214C36.938 17.8214 36.4743 17.2871 36.3478 16.383H33.6914C33.7757 18.5611 35.4201 19.7529 38.1608 19.7529C40.8594 19.7529 42.5037 18.6022 42.5037 16.4652C42.5459 14.3282 41.1123 13.7118 38.5403 13.3419Z"
        fill="white"
      />
      <path
        d="M48.7032 9.31445C46.1733 9.31445 44.2337 10.0542 44.065 12.4378H46.7636C46.8901 11.5747 47.396 11.3281 48.5345 11.3281C49.8416 11.3281 50.2211 11.9857 50.2211 13.1774V13.5884H49.0405C45.8781 13.5884 43.6855 14.4514 43.6855 16.7939C43.6855 18.8898 45.2457 19.7939 47.1431 19.7939C48.7453 19.7939 49.6729 19.1775 50.2632 18.3555V19.5473H53.0461V13.0542C53.0039 10.3008 51.233 9.31445 48.7032 9.31445ZM50.1789 16.0541C50.1789 17.1638 49.2091 17.8213 47.9442 17.8213C46.8901 17.8213 46.4685 17.3282 46.4685 16.6295C46.4685 15.561 47.4382 15.1912 49.0827 15.1912H50.1789V16.0541Z"
        fill="white"
      />
      <path d="M56.9657 5H54.1406V19.589H56.9657V5Z" fill="white" />
      <path
        d="M63.4163 9.31445C60.4226 9.31445 58.1035 11.3692 58.1035 14.5336V14.698C58.1035 17.9035 60.3804 19.7939 63.4584 19.7939C66.2834 19.7939 68.0543 18.6021 68.3916 16.424H65.6931C65.5245 17.287 64.8498 17.8213 63.5427 17.8213C61.9827 17.8213 61.055 16.8761 60.9707 15.1912H68.3916V14.4104C68.4338 10.835 66.0726 9.31445 63.4163 9.31445ZM61.055 13.4651C61.2659 12.0268 62.1513 11.2049 63.4163 11.2049C64.7655 11.2049 65.5666 11.9446 65.651 13.4651H61.055Z"
        fill="white"
      />
      <path
        d="M74.3801 13.3419C72.9044 13.1364 72.3984 12.8899 72.3984 12.2323C72.3984 11.6159 72.9465 11.2049 73.8742 11.2049C74.8439 11.2049 75.35 11.5748 75.4764 12.3967H78.0906C77.8376 10.0954 76.1089 9.27344 73.832 9.27344C71.7238 9.27344 69.7421 10.3008 69.7421 12.3967C69.7421 14.3693 70.7962 15.109 73.5369 15.52C75.0126 15.7255 75.6029 16.0131 75.6029 16.7118C75.6029 17.4104 75.0969 17.8214 74.0006 17.8214C72.7779 17.8214 72.3141 17.2871 72.1876 16.383H69.5312C69.6155 18.5611 71.26 19.7529 74.0006 19.7529C76.6992 19.7529 78.3436 18.6022 78.3436 16.4652C78.3858 14.3282 76.9943 13.7118 74.3801 13.3419Z"
        fill="white"
      />
      <path
        d="M85.7216 9.31506C83.9927 9.31506 82.8965 10.137 82.3901 11.1233V5H79.5234V19.589H82.3901V13.7945C82.3901 12.3151 83.3177 11.5753 84.5408 11.5753C85.8055 11.5753 86.3536 12.2328 86.3536 13.589V19.589H89.221V13.1781C89.1787 10.5068 87.7453 9.31506 85.7216 9.31506Z"
        fill="white"
      />
      <path
        d="M95.3787 9.31445C92.8492 9.31445 90.9094 10.0542 90.7408 12.4378H93.4396C93.5658 11.5747 94.0716 11.3281 95.2101 11.3281C96.5171 11.3281 96.8966 11.9857 96.8966 13.1774V13.5884H95.7165C92.5536 13.5884 90.3613 14.4514 90.3613 16.7939C90.3613 18.8898 91.9216 19.7939 93.8191 19.7939C95.421 19.7939 96.3486 19.1775 96.939 18.3555V19.5473H99.7217V13.0542C99.68 10.3008 97.8665 9.31445 95.3787 9.31445ZM96.855 16.0541C96.855 17.1638 95.8851 17.8213 94.6197 17.8213C93.5658 17.8213 93.144 17.3282 93.144 16.6295C93.144 15.561 94.1139 15.1912 95.7582 15.1912H96.855V16.0541Z"
        fill="white"
      />
      <path
        d="M107.015 9.31445C105.286 9.31445 104.19 10.1364 103.684 11.1227V9.51994H100.816V19.5473H103.684V13.7939C103.684 12.3145 104.611 11.5747 105.834 11.5747C107.099 11.5747 107.647 12.2322 107.647 13.5884V19.5884H110.515V13.1774C110.472 10.5062 109.039 9.31445 107.015 9.31445Z"
        fill="white"
      />
      <path
        d="M119.413 11.0411C118.822 10.0137 117.81 9.31506 116.166 9.31506C113.594 9.31506 111.654 11.2466 111.654 14.5343V14.6986C111.654 18.0273 113.636 19.7945 116.124 19.7945C117.642 19.7945 118.906 18.9315 119.413 17.9041V19.589H122.238V5H119.413V11.0411ZM119.497 14.6164C119.497 16.6301 118.443 17.6164 116.967 17.6164C115.533 17.6164 114.563 16.6301 114.563 14.6575V14.4931C114.563 12.4794 115.449 11.452 117.051 11.452C118.611 11.452 119.497 12.4794 119.497 14.452V14.6164Z"
        fill="white"
      />
      <path
        d="M131.26 9.5625L128.94 15.5625L126.453 9.5625H123.375L127.465 18.5625L125.651 23.0008H128.435L134 9.5625H131.26Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_20758_221794">
        <rect width="134" height="24" fill="white" transform="translate(0 2)" />
      </clipPath>
      <clipPath id="clip1_20758_221794">
        <rect
          width="24.5029"
          height="24"
          fill="white"
          transform="translate(0 2)"
        />
      </clipPath>
    </defs>
  </svg>
);
